// src/components/AppBarSidebar.js
import React, { useState } from 'react';
import HeaderBar from './HeaderBar';
import SidebarNav from './SidebarNav';

const AppBarSidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const openSidebar = () => setSidebarOpen(true);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <>
      <HeaderBar onMenuClick={openSidebar} />
      <SidebarNav open={sidebarOpen} onClose={closeSidebar} />
    </>
  );
};

export default AppBarSidebar;
